import React from 'react';
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import Repeater from '../../../system/fields/Repeater';
import SelectDropdown from "../../../system/fields/SelectDropdown";

import Paragraph from './Paragraph';
import Image from './Image';
import ImageParagraph from './ImageParagraph';
import ParagraphImage from './ParagraphImage';
import TextInput from '../../../system/fields/TextInput';
import Input from './Input';

const Selector = formValueSelector('BlogForm');

class SectionWrapper extends React.Component {

  remove = index => {
    const result = window.confirm('Are you sure you want to remove this row?');
    if (result) {
      this.props.fields.remove(index);
    }
  };

  render() {
    const index = this.props.index;
    const section = this.props.section;
    const fields = this.props.fields;
    return (
      <Repeater key={index}>
        <div className={"toolbar"}>
          {this.props.index + 1 !== this.props.fields.length || this.props.index !== 0 ? (
            <div className="group">
              <span>Move</span>
              {this.props.index + 1 !== this.props.fields.length && (
                <i
                  className="fas fa-angle-down"
                  onClick={() => this.props.fields.move(index, index + 1)}
                />
              )}
              {this.props.index !== 0 && (
                <i
                  className="fas fa-angle-up"
                  onClick={() => this.props.fields.move(index, index - 1)}
                />
              )}
            </div>
          ) : (
              ""
            )}
          <i className="far fa-trash-alt" onClick={() => this.remove(index)} />
        </div>

        {this.props.sectionType === '' && (
          <div className={"top-field"}>
            <Field
              name={`${section}.section_type`}
              type={"text"}
              component={SelectDropdown}
              options={[
                { name: "Paragraph", value: "Paragraph" },
                { name: "Image", value: "Image" },
                { name: "Image-Paragraph", value: "Image-Paragraph" },
                { name: "Paragraph-Image", value: "Paragraph-Image" },
                { name: "Instagram", value: "Instagram" }
              ]}
              valueKey={"value"}
              labelKey={"name"}
              placeholder="Choose a Section type"
            />
          </div>
        )}

        {this.props.sectionType && this.props.sectionType.name === 'Paragraph' && (
          <Paragraph section={section} fields={fields} index={index} key={index} />
        )}
        {this.props.sectionType && this.props.sectionType.name === 'Image' && (
          <Image section={section} fields={fields} index={index} key={index} />
        )}
        {this.props.sectionType && this.props.sectionType.name === 'Image-Paragraph' && (
          <ImageParagraph section={section} fields={fields} index={index} key={index} />
        )}
        {this.props.sectionType && this.props.sectionType.name === 'Paragraph-Image' && (
          <ParagraphImage section={section} fields={fields} index={index} key={index} />
        )}
        {this.props.sectionType && this.props.sectionType.name === 'Instagram' && (
          <Input section={section} fields={fields} index={index} key={index} />
        )}
      </Repeater>
    )
  }
}

const mapStateToProps = (state, props) => ({
  sectionType: Selector(state, `${props.section}.section_type`)
});

export default connect(mapStateToProps)(SectionWrapper);


// WEBPACK FOOTER //
// ./src/containers/Blogs/components/SectionWrapper.jsx